if (!customElements.get('c-collapse')) {
  class Collapse extends HTMLElement {
    constructor() {
      super();
      this.detailsEl = this.querySelector('.collapse_wrapper');
      if (!this.detailsEl) return;
      this.triggerEl = this.detailsEl.querySelector('.collapse_trigger');
      if (!this.triggerEl) return;

      this.linkMenu = this.triggerEl.querySelector('.link--menu');

      this.targetEl = this.triggerEl.nextElementSibling;
      if (!this.targetEl) return;

      this.menuItemsParent = this.closest('menu-items');
      if (this.menuItemsParent) this.menuItems = this.menuItemsParent.querySelectorAll('c-collapse');

      this.backdropClasses = 'bg-white backdrop-blur-sm bg-opacity-50 fixed inset-0 z-5';

      this.init();
    }

    init() {
      this.detailsEl.addEventListener('mouseenter', this.open.bind(this));
      this.detailsEl.addEventListener('mouseleave', this.close.bind(this));
      this.detailsEl.addEventListener('focusout', this.close.bind(this));
    }

    async open() {
      this.linkMenu.classList.add('active');
      this.detailsEl.setAttribute('open', '');
      this.createBackdrop();

      setTimeout(() => {
        if (!this.menuItemsParent.hasOpenCollapse) {
          this.menuItemsParent.hasOpenCollapse = true;
          this.menuItemsParent.classList.remove('with-transition');
        }
      }, 300);
    }

    close() {
      this.linkMenu.classList.remove('active');
      this.detailsEl.removeAttribute('open');
      this.destroyBackdropEl();

      setTimeout(() => {
        const anyOpen = Array.from(this.menuItems).some((item) => item.detailsEl.hasAttribute('open'));

        if (!anyOpen) {
          this.menuItemsParent.hasOpenCollapse = false;
          this.menuItemsParent.classList.add('with-transition');
        }
      }, 0);
    }

    createBackdrop() {
      const backdropEl = document.createElement('div');
      backdropEl.setAttribute('collapse-backdrop', '');
      backdropEl.classList.add(...this.backdropClasses.split(' '));
      if (!document.body.querySelector(`[collapse-backdrop]`)) {
        document.body.append(backdropEl);
      }
    }

    destroyBackdropEl() {
      const backdropEl = document.querySelector(`[collapse-backdrop]`);
      if (backdropEl) {
        backdropEl.remove();
      }
    }
  }

  customElements.define('c-collapse', Collapse);
}

if (!customElements.get('menu-items')) {
  class MenuItems extends HTMLElement {
    constructor() {
      super();
      this.hasOpenCollapse = false;
    }
  }

  customElements.define('menu-items', MenuItems);
}
